<template>
  <div>
    <figure class="image is-16by9">
      <iframe
        class="has-ratio"
        width="560"
        height="315"
        :src="url"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </figure>
  </div>
</template>
<script>
export default {
  name: "videoDemoModal",
  props: {
    url: {
      type: String,
      require: true,
    },
  },
};
</script>
